import { API_ADOBE_HEADER_URL, API_ADOBE_FOOTER_URL } from "./base";
import { wpFetch } from "./wpfetch";

export const fetchAemHeader = async (): Promise<any> => {
  // this accesses a PHP endpoint defined in index.php  which gets the list
  const result = await wpFetch(API_ADOBE_HEADER_URL).catch((err) => {
    console.error("Error fetching AEM header:", err);
    return undefined;
  });

  return result;
};

export const fetchAemFooter = async (): Promise<any> => {
  // this accesses a PHP endpoint defined in index.php  which gets the list
  const result = await wpFetch(API_ADOBE_FOOTER_URL).catch((err) => {
    console.error("Error fetching AEM footer:", err);
    return undefined;
  });

  return result;
};
